document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 560) return;

  const cards = document.querySelectorAll('.product-item');
  cards.forEach((card) => {
    const mainLink = card.querySelector('a[href*="/products/"]');
    const quickViewTrigger = card.querySelector('[data-mobile-quick-view]');

    if (!mainLink || !quickViewTrigger) return;

    quickViewTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const productUrl = mainLink.href;
      const title = card.querySelector('.product-item__title')?.textContent.trim() || '';
      const priceHtml = card.querySelector('.product-item__price-list')?.innerHTML || '';
      const imgSrc = card.querySelector('.product-item__primary-image')?.src || '';
      const galleryDataElement = card.querySelector('.mobile-quick-view-gallery-data');
      const description = card.querySelector('.product-item__description')?.innerHTML || '';
      let gallery = [];

      if (galleryDataElement) {
        try {
          gallery = JSON.parse(galleryDataElement.textContent || '[]');
        } catch (error) {
          gallery = [];
        }
      }

      if (!gallery.length && imgSrc) {
        gallery = [{ src: imgSrc, alt: title }];
      }

      const galleryMarkup = gallery.length
        ? `
        <div class="mobile-quick-view-gallery" style="margin-bottom:16px;">
          <div class="mobile-quick-view-gallery__slider" style="display:block;">
            ${gallery
          .map(
            (item, index) => {
              const imageSource = index === 0 && imgSrc ? imgSrc : item.src;
              return `
              <div class="mobile-quick-view-gallery__slide">
                <img
                  ${index === 0 ? `src="${imageSource}" fetchpriority="high"` : `data-preload-src="${imageSource}"`}
                  loading="${index === 0 ? 'eager' : 'lazy'}"
                  decoding="async"
                  alt="${item.alt || title}"
                  style="width:100%;height:auto;border-radius:12px;display:block;"
                >
              </div>
            `
            }
          )
          .join('')}
          </div>
          <div class="mobile-quick-view-gallery__pagination" style="text-align:center;font-size:13px;font-weight:700;line-height:1.2;color:#1c1814;margin-top:10px;">
            1/${gallery.length}
          </div>
        </div>
      `
        : '';

      let popup = document.getElementById('mobile-product-popup');
      if (!popup) {
        popup = document.createElement('div');
        popup.id = 'mobile-product-popup';
        popup.style.cssText = `position:fixed;inset:0;background:rgba(0,0,0,0.5);display:none;align-items:flex-end;z-index:9999;transition:opacity .3s ease;`;
        popup.innerHTML = `
        <div style="background:#fff;width:100%;max-height:88vh;border-radius:20px 20px 0 0;overflow:hidden;transform:translateY(100%);transition:transform .4s cubic-bezier(0.32,0.72,0,1);">
          <div style="padding:12px 16px;text-align:right;border-bottom:1px solid #eee;">
            <button id="popup-close" style="font-size:28px;line-height:1;background:none;border:none;padding:0 8px;">×</button>
          </div>
          <div id="popup-content" style="padding:0 16px 100px;overflow-y:auto;max-height:calc(88vh - 60px);"></div>
          <div style="position:sticky;bottom:0;background:#fff;padding:16px;border-top:1px solid #eee;">
            <a id="popup-view-details" href="#" class="button button--primary" style="width:100%;display:block;text-align:center;font-size:16px;">View Full Details</a>
          </div>
        </div>
      `;
        document.body.appendChild(popup);
      }

      const previousSlider = popup.querySelector('.mobile-quick-view-gallery__slider');
      if (previousSlider && window.jQuery(previousSlider).hasClass('slick-initialized')) {
        window.jQuery(previousSlider).slick('unslick');
      }

      const popupContent = document.getElementById('popup-content');
      popupContent.innerHTML = `
      ${galleryMarkup}
      <h2 style="font-size: 18px;" class="product-item__title text--strong link">${title}</h2>
      <div style="margin-bottom:20px;">${priceHtml}</div>
      
      <div style="padding-bottom: 16px;">
        <div id="desc-content" style="max-height: 100%;overflow:hidden;transition:max-height .3s ease;font-size:14px;line-height:1.5;color:#333;">
          ${description}
        </div>
      </div>
    `;
      const gallerySlider = document.querySelector('#mobile-product-popup .mobile-quick-view-gallery__slider');
      const galleryPagination = document.querySelector(
        '#mobile-product-popup .mobile-quick-view-gallery__pagination'
      );
      const preloadGalleryImages = () => {
        const deferredImages = popup.querySelectorAll('img[data-preload-src]');
        for (const image of deferredImages) {
          const imageSource = image.getAttribute('data-preload-src');
          if (!imageSource) continue;
          image.src = imageSource;
          image.removeAttribute('data-preload-src');
        }
      };
      const updateGalleryPagination = (activeIndex) => {
        if (!galleryPagination || gallery.length < 2) return;
        galleryPagination.textContent = `${activeIndex + 1} / ${gallery.length}`;
      };

      if (galleryPagination && gallery.length < 2) {
        galleryPagination.style.display = 'none';
      }

      if (gallerySlider && gallery.length > 1) {
        const $gallerySlider = window.jQuery(gallerySlider);
        $gallerySlider.slick({
          dots: false,
          arrows: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
        });

        $gallerySlider.on('afterChange', (_event, _slick, currentSlide) => {
          updateGalleryPagination(currentSlide);
        });
      }

      const detailsBtn = document.getElementById('popup-view-details');
      detailsBtn.href = productUrl;

      // Show popup
      popup.style.display = 'flex';
      popup.setAttribute('data-is-open', 'true');
      requestAnimationFrame(() => {
        popup.style.opacity = '1';
        popup.querySelector('div > div').style.transform = 'translateY(0)';
        popupContent.scrollTo({ top: 0, behavior: 'instant' });
        preloadGalleryImages();
      });

      const closePopup = () => {
        popup.style.opacity = '0';
        popup.querySelector('div > div').style.transform = 'translateY(100%)';
        setTimeout(() => {
          popup.style.display = 'none';
          popup.setAttribute('data-is-open', 'false');
        }, 100);
      };

      document.getElementById('popup-close').onclick = closePopup;
      popup.onclick = (ev) => {
        if (ev.target === popup) closePopup();
      };
    });
  });
});
